const storageData = JSON.parse(sessionStorage.getItem('ubunconsole'))
let activeAmcProfile = {}
let amcProfiles = []

if (storageData) {
  activeAmcProfile = storageData.amcProfile.activeAmcProfile
  amcProfiles = storageData.amcProfile.amcProfiles
}

const moduleAmcProfile = {
  namespaced: true,
  state: {
    activeAmcProfile,
    amcProfiles: amcProfiles || []
  },
  getters: {
  },
  mutations: {
    SET_AMC_PROFILES: (state, payload) => {
      state.amcProfiles = payload
    },
    SET_ACTIVE_AMC_PROFILE: (state, payload) => {
      state.activeAmcProfile = payload
    },
  },
  actions: {
    setAcitveAmcProfileByAccount ({ commit, state }, payload) {
      state.amcProfiles.map(profile => {
        if (profile.sellerId === payload.sellerId) {
          commit('SET_ACTIVE_AMC_PROFILE', profile)
        }
      })
    },
    updateAmcProfile ({ commit, state }, payload) {
      commit('SET_AMC_PROFILES', state.amcProfiles.map(profile =>
        (profile.amazonAccountId === payload.amazonAccountId) ? payload : profile)
      )
      for (const i in state.amcProfiles) {
        if (state.amcProfiles[i].amazonAccountId === payload.amazonAccountId) {
          commit('SET_ACTIVE_AMC_PROFILE', state.amcProfiles[i])
        }
      }
    }
  }
}

export default moduleAmcProfile
